import React from "react";
import { Link } from "react-router-dom";

const NavigationPage = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>페이지 네비게이션</h1>
      <ul style={{ listStyleType: "none", padding: 0 }}>
        <li>
          <Link to="/admin-login">로그인 (Login)</Link>
        </li>
        <li>
          <Link to="/">홈 (Home)</Link>
        </li>
        <li>
          <Link to="/home-update">홈 업데이트 (Home Update)</Link>
        </li>
        <li>
          <Link to="/reels-category">릴스 모아보기 (Reels Category)</Link>
        </li>
        <li>
          <Link to="/reels-category-upsert">
            릴스 카테고리 업서트 (Reels Category Upsert)
          </Link>
        </li>
        <li>
          <Link to="/reels-list">릴스 리스트 (Reels List)</Link>
        </li>
        <li>
          <Link to="/reels-upsert">릴스 업서트 (Reels Upsert)</Link>
        </li>
        <li>
          <Link to="/product-list">
            상품 소개 리스트 (Product Introduce List)
          </Link>
        </li>
        <li>
          <Link to="/product-upsert">상품 업서트 (Product Upsert)</Link>
        </li>
        <li>
          <Link to="/detail-category">
            심화 정보 - 상세 카테고리 (Detail Category)
          </Link>
        </li>
        <li>
          <Link to="/detail-category-upsert">
            심화 정보 - 카테고리 업서트 (Detail Category Upsert)
          </Link>
        </li>
        <li>
          <Link to="/detail-list">
            심화 정보 - 상세 리스트 (Detail Info List)
          </Link>
        </li>
        <li>
          <Link to="/detail-list-upsert">
            심화 정보 - 리스트 업서트 (Detail Info List Upsert)
          </Link>
        </li>
        <li>
          <Link to="/detail-contents">
            심화 정보 - 상세 콘텐츠 (Detail Contents)
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default NavigationPage;
